var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('gmap-map',{ref:"myMap",staticStyle:{"width":"100%","height":"640px"},attrs:{"id":"street-layer-map","center":_vm.gMapPosition,"zoom":16,"options":{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: true,
                rotateControl: true,
                fullscreenControl: true,
                disableDefaultUi: false
              },"map-type-id":"roadmap"}},[_c('gmap-marker',{ref:"myMarker",attrs:{"position":_vm.gMapPosition,"draggable":_vm.bDraggable,"clickable":_vm.bClickable,"title":_vm.markerTitle},on:{"click":function($event){return _vm.toggleInfoWindow($event.latLng)},"drag":function($event){return _vm.gMapDrag($event.latLng)},"dragstart":function($event){return _vm.gMapDragStart($event.latLng)},"dragend":function($event){return _vm.gMapDragEnd($event.latLng)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }